import '../App.css';
import React from 'react';
import { connect } from 'react-redux'
import { language } from '../language';
import Moment from 'moment-timezone';
import 'react-datepicker/dist/react-datepicker.css';
import JSEncrypt from 'jsencrypt';
import SideBar from '../Component/SideBar';
const { homeDisplayPackage, getBackupWords, getPublicKey, chgPwd, displaySpecialUser, getInformation, getPackageBackupF, getBackupFightingF, dadingIDListFNC, getBackupJackpot } = require('../Api');
const { exportBackupExcel, exportPackageBackupExcel, exportBackupJackpotTxt } = require('../jsonToXlsx');
var timer

const utilizeScroll = () => {
  
  const elRef = React.createRef();
  const executeScroll = () => elRef.current.scrollIntoView({behavior: "smooth", block: "end", inline: "nearest"});

  return { executeScroll, elRef };
};

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: this.props.username,
      UserID: this.props.userID,
      token: this.props.token,
      TodayDate: Moment(new Date()).format('DD/MM/YYYY (ddd)'),
      SelectedDate: Moment(localStorage.getItem('SELECTED_DATE')).toDate(),
      SelectedFightingDate: new Date(),
      Authority: '',
      DisplayPakege: false,
      getPackagename: [],
      SelectedPackageID: '',
      Run: false,
      date: new Date(),
      ChangePasswordModal: false,
      CShowPassword: false,
      ShowPassword: false,
      RShowPassword: false,
      CPassword: '',
      NPassword: '',
      RPassword: '',
      showNotification: false,
      SpecialUsers: '',
      AdvertisementModal: false,
      NewOption: [],
      ImageNews: '',
      background: '#eb5f5f',
      backgroundclose: 'white',
      downliadDading: '',
      LastDadingTime: '',
      PopScrollBackButton: false,
      Word: 'C',
      GamesDisplay: '',
      DownFightingModal: false,
      loading: false,
      problemModalUserList: false,
      problemListData: [],
    }
    this.elScroll = utilizeScroll();
    this.closeDeleteProblemListModal = this.closeDeleteProblemListModal.bind(this)
  }

  async componentDidMount() {
    this.SetUsersAuthorities();
    this.timerID = setInterval(
      () => this.tick(),
      1000
    );
    if (this.props.Role === 'superAdmin') {
      this.getdisplaySpecialUser();
    }
    const GDisplay = localStorage.getItem('GameDisplay');

    this.setState({
      GamesDisplay: GDisplay,
    })
  }

  async getdisplaySpecialUser() {
    const getSpecialUsers = await displaySpecialUser(this.props.username, this.props.token)
    if (getSpecialUsers.message === 'No Special User') {
      this.setState({ SpecialUsers: '' })
    } else {
      this.setState({ SpecialUsers: getSpecialUsers })
    }
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  tick() {
    this.setState({
      date: new Date()
    });
  }

  async SetUsersAuthorities() {
    const UserAuthorities = JSON.parse(this.props.UserAuthority)
    const LoginStatus = localStorage.getItem('LoginStatus');
    if (Number(LoginStatus) === 0) {
      this.setState({ ChangePasswordModal: true })
    } 
    this.setState({
      Authority: UserAuthorities,
    })
    const resultInformation = await getInformation('latest',this.props.username, this.props.token)
    this.setState({NewOption: resultInformation})
  }

  handleChange(value, field) {
    this.setState({ [field]: value });
  }

  async ShowPackage() {
    if(this.state.DisplayPakege === false) {
      let getPackagename = await homeDisplayPackage(this.props.username, this.props.token, this.props.userID)
      if(getPackagename.message === 'User No Package') {
        this.setState({ getPackagename: [], DisplayPakege: true })
      } else {
        getPackagename = getPackagename.sort(function(a,b){
          if ((a.childPackage === null) === (b.childPackage === null)) {
            return a.Name.localeCompare(b.Name);
          }
          return (a.childPackage === null) - (b.childPackage === null)
        })
        this.setState({ getPackagename, DisplayPakege: true })
      }
    } else {
      this.setState({ getPackagename: [], DisplayPakege: false, Run: false, SelectedPackageID: '' })
    }
  }

  OpenDisplayPack(PackageID) {
    this.setState({ Run: false }, ()=> {
      this.setState({ SelectedPackageID: PackageID, Run: true })
    })
  }

  async GoToBet() {
    this.props.history.push('/betting')
  }

  GoToReceipt() {
    this.props.history.push('/ViewReceipt')
  }

  GoToResult() {
    this.props.history.push('/ViewResult')
  }

  GoToReport() {
    this.props.history.push('/DownlineReport')
  }

  GoToSetting() {
    this.props.history.push('/Setting')
  }

  GoToHitSale() {
    this.props.history.push('/Hit_Sales')
  }

  async exportBackup(Type) {
    const GDisplay = localStorage.getItem('GameDisplay');
    if (Type === 'Backup') {
      this.setState({ loading: true})
      const wordsList = await getBackupWords(this.props.username, this.props.token)
      await exportBackupExcel( wordsList, this.props.currentLanguage, 'wordsList', this.state.GamesDisplay)
      this.setState({ loading: false})
    } else if(Type === 'Fighting') {
      this.setState({ DownFightingModal: !this.state.DownFightingModal})
    } else if (Type === 'Jackpot') {
      this.setState({ loading: true})
      const wordsList = await getBackupJackpot(this.props.username, this.props.token)
      await exportBackupJackpotTxt( wordsList)
      this.setState({ loading: false})
    } else {
      const GetPackage = await getPackageBackupF(this.props.Role, this.props.username, this.props.token);
      if(GetPackage.Message === 'Success') {
        await exportPackageBackupExcel(GetPackage.Package , this.props.currentLanguage, {Username: this.props.username, UserID: this.props.userID}, GDisplay)
      }
    } 
  }

  async DownloadFightingBackup() {
    const SelectedFightingDate = Moment(this.state.SelectedFightingDate).format('YYYY-MM-DD')
    const FightingBackup = await getBackupFightingF(this.props.username, SelectedFightingDate, this.props.token)
    await exportBackupExcel(FightingBackup, this.props.currentLanguage, 'fighting', this.state.GamesDisplay)
    if (FightingBackup) {
      this.setState({ DownFightingModal: !this.state.DownFightingModal })
    }
  }

  async setSelectedDate(date, mode) {
    this.setState({
      [mode]: date
    });
  }

  async ChangePassword(){
    if ((this.state.CPassword).length === 0){
      this.setState({ notificationType: 'error', notificationMessage: language[this.props.currentLanguage].CurrentPasswordEmpty }, () => {
        this.openNotification()
      });
    } else if ((this.state.NPassword).length === 0){
      this.setState({ notificationType: 'error', notificationMessage: language[this.props.currentLanguage].NewPasswordEmpty }, () => {
        this.openNotification()
      });
    } else if ((this.state.RPassword).length === 0){
      this.setState({ notificationType: 'error', notificationMessage: language[this.props.currentLanguage].RepeatPasswordEmpty }, () => {
        this.openNotification()
      });
    } else if ( this.state.NPassword !== this.state.RPassword){
      this.setState({ notificationType: 'error', notificationMessage: language[this.props.currentLanguage].NRPasswordDifferent }, () => {
        this.openNotification()
      });
    } else {
      const PublicKey = await getPublicKey();
      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(PublicKey.publicKey);
      let CnPassword = encrypt.encrypt(this.state.CPassword);
      let NnPassword = encrypt.encrypt(this.state.NPassword);

      const PasswordResult = await chgPwd(this.props.userID, CnPassword, NnPassword, this.props.username, this.props.token)
      if (PasswordResult.message === 'Password Changed Successfully'){
        this.setState({notificationType: 'success', notificationMessage: language[this.props.currentLanguage].PasswordChangedSuccessfully}, ()=>{
          this.openNotificationSuccess(PasswordResult.message)
          localStorage.setItem('LoginStatus', 1)
        })
      } else {
        this.setState({ notificationType: 'error', notificationMessage: PasswordResult.error }, () => {
        });
      }
    }
  }

  openNotificationSuccess(message) {
    this.setState({ showNotification: true });
    clearTimeout(timer)
    timer = setTimeout(() => {
      this.setState({ showNotification: false });
      this.setState({ notificationMessage: '', ChangePasswordModal: false });
    }, 500);
  };

  openNotification(message) {
    this.setState({ showNotification: true });
    clearTimeout(timer)
    timer = setTimeout(() => {
      this.setState({ showNotification: false });
      this.setState({ notificationMessage: '' });
    }, 5000);
  };

  handleScroll = (event) => {    
    var node = event.target;
    const bottom = node.scrollHeight - node.scrollTop === node.clientHeight;
    if (bottom) {
      this.setState({PopScrollBackButton: bottom})
    } else {
      this.setState({PopScrollBackButton: bottom}) 
    }
  }

  closeDeleteProblemListModal() {
    this.setState({ problemModalUserList: false, problemListData: [] })
  }

  async CallProblemList() {
    const UserLists = await dadingIDListFNC(this.props.token, this.props.username)
    if (UserLists) {
      this.setState({ problemListData: UserLists }, () => {
        this.setState({ problemModalUserList: true })
      })
    }
  }

  render() {
    return (
      <div>
        <SideBar />
        <div style={{ fontSize: 25, marginLeft: 150, padding: 10, width: `calc(100% - 150)`, flexDirection: 'column', display: 'flex', alignItems: 'flex-start' }}>
          <div style={{  fontWeight: 'bold'}}>{language[this.props.currentLanguage].Date}: {this.state.TodayDate} {this.state.date.toLocaleTimeString()}</div>
          <div style={{ marginBottom: 5, padding: 2 }}>{language[this.props.currentLanguage].ClaseTime} : </div>
          <div style={{ marginBottom: 5, padding: 2 }}><input style={{ textAlign: 'center', width: 100 }} readOnly={true} value={'7.00 PM'}/> {language[this.props.currentLanguage].CloseTimePlatform1}</div>
          <div style={{ marginBottom: 5, padding: 2 }}><input style={{ textAlign: 'center', width: 100 }} readOnly={true} value={'6.25 PM'}/> {language[this.props.currentLanguage].CloseTimePlatform2}</div>
          <div style={{ padding: 2, marginBottom: 5 }}><input style={{ textAlign: 'center', width: 100 }} readOnly={true} value={'7.00 PM'}/> {language[this.props.currentLanguage].GrandDragon} </div>
          <div style={{ padding: 2 }}><input style={{ textAlign: 'center', width: 100 }} readOnly={true} value={'7.00 PM'}/> 9Lotto(9) </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    username: state.username,
    userID: state.userID,
    token: state.token,
    Role: state.Role,
    hide: state.hide,
    currentLanguage: state.currentLanguage,
    UserAuthority: state.UserAuthority,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    setLoginStatus: (Username, UserToken, Role) => {
      dispatch({
        type: 'LOGIN_STATUS',
        payload: {
          username: Username,
          token: UserToken,
          Role: Role,
        },
      });
    },
    setDate: (Date) => {
      dispatch({
        type: 'SELECTED_DATE',
        payload: Date,
      });
    },
    setLanguage: (lg) => {
      dispatch({ type: 'SET_LANGUAGE', payload: lg });
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
